/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryGroupIdMoveBody
 */
export interface LaundryGroupIdMoveBody {
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupIdMoveBody
     */
    targetOrganizationId: string;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupIdMoveBody
     */
    targetLaundryGroupId: string;
}

/**
 * Check if a given object implements the LaundryGroupIdMoveBody interface.
 */
export function instanceOfLaundryGroupIdMoveBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "targetOrganizationId" in value;
    isInstance = isInstance && "targetLaundryGroupId" in value;

    return isInstance;
}

export function LaundryGroupIdMoveBodyFromJSON(json: any): LaundryGroupIdMoveBody {
    return LaundryGroupIdMoveBodyFromJSONTyped(json, false);
}

export function LaundryGroupIdMoveBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupIdMoveBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetOrganizationId': json['targetOrganizationId'],
        'targetLaundryGroupId': json['targetLaundryGroupId'],
    };
}

export function LaundryGroupIdMoveBodyToJSON(value?: LaundryGroupIdMoveBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'targetOrganizationId': value.targetOrganizationId,
        'targetLaundryGroupId': value.targetLaundryGroupId,
    };
}

